import FindReplaceCtrl from './findReplace.controller'
import template from './findReplace.tmpl.html'

export default {
  template,
  replace: true,
  restrict: 'EA',
  controller: FindReplaceCtrl,
  controllerAs: 'vm',
  bindings: {},
}
